module.exports = __webpack_public_path__ + "img/horizontal_3_1_7005.2d119c14.png";